
import React from 'react';
import FadeIn from '../../components/FadeIn';
import SEO from '../../components/SEO';

const TermsOfService = () => {
    return (
        <div className="bg-white pt-32 pb-20 px-4 sm:px-6 lg:px-8">
            <SEO title="Terms of Service | BPO Consultants" description="Rules and regulations for using our website." />
            <FadeIn className="max-w-4xl mx-auto">
                <h1 className="text-4xl font-bold text-[#20222D] mb-8">Terms of Service</h1>
                <div className="prose prose-lg text-gray-600">
                    <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
                    <p className="mb-6">Please read these Terms of Service carefully before using our website operated by BPO Consultants.</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">1. Conditions of Use</h2>
                    <p className="mb-4">By using this website, you certify that you have read and reviewed this Agreement and that you agree to comply with its terms. If you do not want to be bound by the terms of this Agreement, you are advised to leave the website accordingly.</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">2. Intellectual Property</h2>
                    <p className="mb-4">You agree that all materials, products, and services provided on this website are the property of BPO Consultants, its affiliates, directors, officers, employees, agents, suppliers, or licensors including all copyrights, trade secrets, trademarks, patents, and other intellectual property.</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">3. User Accounts</h2>
                    <p className="mb-4">As a user of this website, you may be asked to register with us and provide private information. You are responsible for ensuring the accuracy of this information, and you are responsible for maintaining the safety and security of your identifying information.</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">4. Limitation of Liability</h2>
                    <p className="mb-4">BPO Consultants is not liable for any damages that may occur to you as a result of your misuse of our website.</p>
                </div>
            </FadeIn>
        </div>
    );
};

export default TermsOfService;
